import { useEffect } from 'react'
import { useWeatherStore } from '@/stores/weatherStore'
import { useSettingsStore } from '@/stores/settingsStore'
import { WEATHER_CACHE_TTL } from '@/services/weatherService'

export function useWeather() {
  const weatherEnabled = useSettingsStore((s) => s.settings.weatherThemeEnabled)

  useEffect(() => {
    if (!weatherEnabled) return

    // Initial fetch if stale
    if (useWeatherStore.getState().isStale()) {
      useWeatherStore.getState().fetchWeather()
    }

    // Periodic polling
    const interval = setInterval(() => {
      if (useWeatherStore.getState().isStale()) {
        useWeatherStore.getState().fetchWeather()
      }
    }, WEATHER_CACHE_TTL)

    // Re-fetch on tab visibility if stale
    const handleVisibility = () => {
      if (document.visibilityState === 'visible' && useWeatherStore.getState().isStale()) {
        useWeatherStore.getState().fetchWeather()
      }
    }
    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [weatherEnabled])
}
